export interface HelpPageContent {
  title: string;
  description: string;
  actions: string[];
  faq: { q: string; a: string }[];
}

export const helpPages: Record<string, HelpPageContent> = {
  dashboard: {
    title: 'Dashboard',
    description: 'Das Dashboard bietet eine Übersicht über die wichtigsten Kennzahlen und Aktivitäten.',
    actions: [
      'KPIs und Statistiken einsehen',
      'Schnellzugriff auf häufig genutzte Funktionen',
      'Aktuelle Benachrichtigungen prüfen',
    ],
    faq: [
      { q: 'Wie kann ich das Dashboard anpassen?', a: 'Dashboard-Widgets können in den Einstellungen konfiguriert werden.' },
      { q: 'Werden die Daten in Echtzeit aktualisiert?', a: 'Ja, die KPIs werden alle 30 Sekunden automatisch aktualisiert.' },
    ],
  },
  employees: {
    title: 'Mitarbeiter',
    description: 'Verwalten Sie alle Mitarbeiterdaten, Kompetenzen und Arbeitszeiten.',
    actions: [
      'Mitarbeiter suchen und filtern',
      'Neue Mitarbeiter anlegen',
      'Mitarbeiterdaten bearbeiten',
      'Kompetenzen verwalten',
      'Arbeitszeiten einsehen',
    ],
    faq: [
      { q: 'Wie lege ich einen neuen Mitarbeiter an?', a: 'Klicken Sie auf "Erstellen" und füllen Sie das Formular aus.' },
      { q: 'Kann ich Mitarbeiter exportieren?', a: 'Ja, über die Export-Funktion können Sie Mitarbeiterlisten als CSV herunterladen.' },
    ],
  },
  corporations: {
    title: 'Firmen',
    description: 'Verwalten Sie Firmendaten, Standorte, Kontakte und Organisationseinheiten.',
    actions: [
      'Firmen durchsuchen und filtern',
      'Firmendetails einsehen und bearbeiten',
      'Kontaktpersonen verwalten',
      'Organisationseinheiten pflegen',
    ],
    faq: [
      { q: 'Wie erstelle ich eine neue Firma?', a: 'Nutzen Sie den "Erstellen"-Button und füllen Sie die Pflichtfelder aus.' },
      { q: 'Was sind Organisationseinheiten?', a: 'OUs bilden die Hierarchie einer Firma ab (Abteilungen, Teams, etc.).' },
    ],
  },
  calendar: {
    title: 'Kalender',
    description: 'Kalenderansicht zur Verwaltung von Terminen, Abwesenheiten und Feiertagen.',
    actions: [
      'Termine erstellen, bearbeiten und löschen',
      'Zwischen Zeitraster- und Listenansicht wechseln',
      'Nach Titel oder Teilnehmer filtern',
      'Nur eigene Termine anzeigen (Toggle)',
      'Verfügbarkeit von Teilnehmern prüfen',
      'Vor-/Nachlaufzeiten für Termine festlegen',
      'Serientermine konfigurieren',
      'Abwesenheiten und Feiertage einsehen',
      'Kalender-Sidebar: Mini-Kalender, Filter, Einstellungen, Legende',
    ],
    faq: [
      { q: 'Was bedeuten die schraffierten Bereiche?', a: 'Schraffierte Bereiche kennzeichnen Vor- und Nachlaufzeiten eines Termins (z.\u00A0B. Anfahrt, Aufbau, Nachbereitung).' },
      { q: 'Warum kann ich nicht speichern?', a: 'Mindestens ein Teilnehmer hat eine Terminüberschneidung. Prüfen Sie die Verfügbarkeitsanzeige und passen Sie den Zeitraum an.' },
      { q: 'Warum sehe ich bei manchen Abwesenheiten keinen Grund?', a: 'Aus Datenschutzgründen (DSGVO) wird bei bestimmten Abwesenheitsarten der Grund nicht angezeigt. Die Sichtbarkeit wird pro Abwesenheitsart in den Stammdaten konfiguriert.' },
      { q: 'Wie wechsle ich die Ansicht?', a: 'In der Kalender-Sidebar unter Einstellungen können Sie zwischen Zeitraster- und Listenansicht umschalten.' },
      { q: 'Was bedeuten die Farben?', a: 'Eigene Termine werden in Petrol dargestellt, fremde Termine heller. Individuelle Farben können pro Termin eingestellt werden. Die aktuelle Zuordnung finden Sie in der Legende der Sidebar.' },
    ],
  },
  admin: {
    title: 'Administration',
    description: 'Systemeinstellungen, Benutzerverwaltung und Konfiguration.',
    actions: [
      'Benutzer und Rollen verwalten',
      'Systemeinstellungen anpassen',
      'Audit-Log einsehen',
    ],
    faq: [
      { q: 'Wer hat Zugriff auf die Administration?', a: 'Nur Benutzer mit Administratorrechten haben Zugriff.' },
    ],
  },
};

const defaultHelp: HelpPageContent = {
  title: 'Hilfe',
  description: 'Wählen Sie eine Seite, um kontextbezogene Hilfe anzuzeigen.',
  actions: ['Navigation nutzen, um zu einer Seite zu wechseln'],
  faq: [
    { q: 'Wo finde ich weitere Hilfe?', a: 'Besuchen Sie das Hilfe-Center für ausführliche Dokumentation.' },
  ],
};

export function getHelpForRoute(pathname: string): HelpPageContent {
  if (pathname.includes('employee')) return helpPages.employees!;
  if (pathname.includes('corporation')) return helpPages.corporations!;
  if (pathname.includes('calendar') || pathname.includes('absence') || pathname.includes('booking') || pathname.includes('holiday')) return helpPages.calendar!;
  if (pathname.includes('admin')) return helpPages.admin!;
  if (pathname === '/' || pathname.includes('dashboard')) return helpPages.dashboard!;
  return defaultHelp;
}
